/// <amd-module name="Search/Code/Components/Results" />

import * as React from "react";
import * as Container from "Search/Shared/Base/Container";
import { OverlayContainer } from "Search/Code/Components/Overlay";
import { ZeroDataContainer } from "Search/Code/Components/ZeroData";
import { FilterPaneContainer } from "Search/Code/Components/FilterPaneContainer";
import { ActionCreator } from "Search/Code/Flux/ActionCreator";
import { StoresHub, IAggregatedState, StoreName } from "Search/Code/Flux/StoresHub";
import { SplitterContainer } from "Search/Code/Components/Splitter";

export interface IResultsContainerProps<
    TStoreName extends string,
    TActionCreator,
    TAggregatedState,
    TStoresHub extends Container.IStoresHub<TStoreName, TAggregatedState>>
    extends Container.IContainerProps<TStoreName, TActionCreator, TAggregatedState, TStoresHub> {
    isFullScreen: boolean;
}

export const ResultsContainer = (props: IResultsContainerProps<StoreName, ActionCreator, IAggregatedState, StoresHub>) => {
    return (
        <div className="search-view-container flex-column flex-grow v-scroll-auto">
            <FilterPaneContainer {...props} />
            <div className="search-results flex-column flex-grow scroll-hidden relative">
                <OverlayContainer {...props} />
                <ZeroDataContainer {...props} />
                <SplitterContainer {...props} />
            </div>
        </div>
    );
}